import Login from "./Auth/Login";
import Register from "./Auth/Register";
import Forgot from './Auth/ForgotPass/Index';
import EnterCode from './Auth/EnterCode';
import {Route} from 'react-router-dom';

const RestrictedRoutes = () => {
    return (
        <>
            <Route exact path="/" component={Login}/>
            <Route exact path="/register" component={Register}/>
            <Route exact path="/login-enter-code" component={EnterCode}/>
            <Route path="/forgot" component={Forgot}/>
        </>
    )
}

export default RestrictedRoutes
